<div class="sidebar">
  <div id="sidebar-collapse">
    <div class="admin-block d-flex" style="align-items: center;">
      <div>
        <img src="./../../../assets/img/dash/hrms.png" class="img-circle" width="45px" />
      </div>
      <div class="admin-info">
        <div class="font-strong" (click)="home()">{{auth.allSystemModuleObj['HR']}}</div>
      </div>
    </div>
    <ul class="side-menu metismenu">
      <li>
        <a (click)="refreshCol()" routerLinkActive="active" routerLink="/hrms/hrms-index"><i
            class="sidebar-item-icon fa fa-th-large"></i>
          <!-- <a [hidden]="dashborad_hidden" routerLinkActive="active" routerLink="/hrms/index"><i class="sidebar-item-icon fa fa-th-large"></i> -->
          <span class="nav-label">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar1']}}</span>
        </a>
      </li>
      <li [hidden]="!sideBarFlag['HR-R45']">
        <a routerLinkActive="active" (click)="refreshCol()" routerLink="/hrms/myinfo"><i
            class="sidebar-item-icon fa fa-users"></i>
          <span class="nav-label">My Info</span>
        </a>
      </li>
      <li [hidden]="!sideBarFlag['HR-R46']">
        <a routerLinkActive="active" (click)="refreshCol()" routerLink="/hrms/mark-attendance"><i
            class="sidebar-item-icon  fa fa-check-square" aria-hidden="true"></i>
          <span class="nav-label">

            Mark Attendance
          </span>
        </a>
      </li>
      <!-- <li>
                <a routerLinkActive="active" routerLink="/hrms/mkattend"><i class="sidebar-item-icon  fa fa-check-square" aria-hidden="true"></i>
                    <span
                        class="nav-label">


                        Mark Attendance
                    </span>
                </a>
            </li> -->
      <li [hidden]="!sideBarFlag['HR-R47']">
        <a (click)="refreshCol()" routerLink="/hrms/notice"><i class="sidebar-item-icon fa fa-bell-o rel"></i>
          <span class="nav-label">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar3']}}
            <!-- Notice -->
          </span>
        </a>
      </li>
      <li [hidden]="!sideBarFlag['HR-R5']">
        <a class="text-decoration-none" href="#" data-bs-toggle="collapse" data-bs-target="#collapseReport"
          aria-expanded="false" aria-controls="collapseReport"><i class="sidebar-item-icon fa fa-bar-chart"></i>
          <!-- <a [hidden]="report_hidden" href="javascript:;"><i class="sidebar-item-icon fa fa-bar-chart"></i> -->
          <span class="nav-label">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar4']}}
            <!-- Report -->
          </span><i class="fa fa-angle-left arrow"></i></a>
        <ul class="nav-2-level collapse" id="collapseReport" data-bs-parent="#sidebar-collapse">
          <li [hidden]="!sideBarFlag['HR-R48']">
            <a routerLink="/hrms/hrms-report/emp-report"
              routerLinkActive="active">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar5']}}
              <!-- Employee -->
            </a>
          </li>
          <li [hidden]="!sideBarFlag['HR-R49']">
            <a routerLink="/hrms/hrms-report/payroll-report"
              routerLinkActive="active">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar6']}}
              <!-- Salary Component -->
            </a>
          </li>
          <li [hidden]="!sideBarFlag['HR-R50']">
            <a routerLink="/hrms/hrms-report/bill-report"
              routerLinkActive="active">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar7']}}
              <!-- Bill -->
            </a>
          </li>
          <!--
                    <li>
                        <a routerLink="/hrms/hrms-report/lpc"
                            routerLinkActive="active">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar8']}}
                    -->
          <!-- LPC -->
          <!--
                        </a>
                    </li>
                -->
          <!-- <li>
                        <a routerLink="/hrms/hrms-report/lpc"
                            routerLinkActive="active">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar8']}} -->
          <!-- LPC -->
          <!-- </a>
                    </li> -->
          <li [hidden]="!sideBarFlag['HR-R51']">
            <a routerLink="/hrms/hrms-report/lpctransfer"
              routerLinkActive="active">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar69']}}
              <!-- LPC-TRANSFER -->
            </a>
          </li>
          <li [hidden]="!sideBarFlag['HR-R52']">
            <a routerLink="/hrms/hrms-report/pay-slip"
              routerLinkActive="active">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar10']}}
              <!-- Pay Slip -->
            </a>
          </li>
          <li [hidden]="!sideBarFlag['HR-R98']">
            <a routerLink="/hrms/hrms-report/advance-report" routerLinkActive="active">
              Advance Report
            </a>
          </li>
          <li [hidden]="!sideBarFlag['HR-R53']">
            <a routerLink="/hrms/hrms-report/pention-contribution"
              routerLinkActive="active">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar11']}}
              <!-- Pension Cont. -->
            </a>
          </li>
          <li [hidden]="!sideBarFlag['HR-R54']">
            <a routerLink="/hrms/hrms-report/deduction-report"
              routerLinkActive="active">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar12']}}
              <!-- PF/IT -->
            </a>
          </li>
          <li [hidden]="!sideBarFlag['HR-R55']">
            <a routerLink="/hrms/hrms-report/hold"
              routerLinkActive="active">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar13']}}
              <!-- Salary Hold -->
            </a>
          </li>
          <li [hidden]="!sideBarFlag['HR-R56']">
            <a routerLink="/hrms/hrms-report/annl"
              routerLinkActive="active">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar14']}}
              <!-- Annual Salary Statement -->
            </a>
          </li>
          <li [hidden]="!sideBarFlag['HR-R57']">
            <a routerLink="/hrms/hrms-report/varannl"
              routerLinkActive="active">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar68']}}
              <!-- Annual Salary Statement -->
            </a>
          </li>
          <li [hidden]="!sideBarFlag['HR-R58']">
            <a routerLink="/hrms/hrms-report/atten-report" routerLinkActive="active">
              Attendance Report
            </a>
          </li>
        </ul>
      </li>

      <li [hidden]="!sideBarFlag['HR-R2']">
        <a class="text-decoration-none" href="#" data-bs-toggle="collapse" data-bs-target="#collapseEmp"
          aria-expanded="false" aria-controls="collapseEmp"><i class="sidebar-item-icon fa fa-users"></i>
          <!-- <a [hidden]="party_hidden" href="javascript:;"><i class="sidebar-item-icon fa fa-users"></i> -->
          <span class="nav-label">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar15']}}
            <!-- Employee -->
          </span><i class="fa fa-angle-left arrow"></i></a>
        <ul class="nav-2-level collapse" id="collapseEmp" data-bs-parent="#sidebar-collapse">
          <li [hidden]="!sideBarFlag['HR-R59']">
            <a routerLink="/hrms/party/list" routerLinkActive="active">LIST
              <!-- List-->
            </a>
          </li>
          <li [hidden]="!sideBarFlag['HR-R60']">
            <!-- Joining -->
            <a routerLink="/hrms/party/allemp"
              routerLinkActive="active">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar16']}}
              <!-- All Employee -->
            </a>
          </li>
          <!-- Joining -->
          <!--  <li>
                        <a routerLink="/hrms/party/joining" routerLinkActive="active">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar17']}}
                           </a>
                    </li> -->
          <!-- <li>
                        <a routerLink="/hrms/party/personal-info" routerLinkActive="active">Personal Info</a>
                    </li> -->
          <li [hidden]="!sideBarFlag['HR-R61']">
            <a routerLink="/hrms/party/edu-info"
              routerLinkActive="active">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar18']}}
              <!-- Education Info -->
            </a>
          </li>
          <li [hidden]="!sideBarFlag['HR-R62']">
            <a routerLink="/hrms/party/nom-info"
              routerLinkActive="active">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar19']}}
              <!-- Nominee Info -->
            </a>
          </li>
          <li [hidden]="!sideBarFlag['HR-R63']">
            <a routerLink="/hrms/party/bank-dtl-info"
              routerLinkActive="active">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar20']}}
              <!-- Bank Detail -->
            </a>
          </li>
          <li [hidden]="!sideBarFlag['HR-R64']">
            <a routerLink="/hrms/party/lic"
              routerLinkActive="active">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar21']}}
              <!-- LIC -->
            </a>
          </li>
          <li [hidden]="!sideBarFlag['HR-R65']">
            <a routerLink="/hrms/party/dependent-info"
              routerLinkActive="active">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar22']}}
              <!-- Dependent Info -->
            </a>
          </li>




        </ul>
      </li>

      <li routerLinkActive="active" [hidden]="!sideBarFlag['HR-R7']">
        <a class="text-decoration-none" href="#" data-bs-toggle="collapse" data-bs-target="#collapseEst"
          aria-expanded="false" aria-controls="collapseEst"><i class="sidebar-item-icon fa fa-gear"></i>
          <!-- <a [hidden]="arr_hidden" href="javascript:;"><i class="sidebar-item-icon fa fa-gear"></i> -->
          <span class="nav-label">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar23']}}
            <!-- Establishment -->
          </span><i class="fa fa-angle-left arrow"></i></a>
        <ul class="nav-2-level collapse" id="collapseEst" data-bs-parent="#sidebar-collapse">
          <li [hidden]="!sideBarFlag['HR-R66']">
            <a routerLink="/hrms/arr/establish"
              routerLinkActive="active">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar24']}}
              <!-- Establish -->
            </a>
          </li>
          <li [hidden]="!sideBarFlag['HR-R97']">
            <a routerLink="/hrms/arr/bonus" routerLinkActive="active">
              Bonus
              <!-- {{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar24']}} -->

            </a>
          </li>
          <li>
            <a routerLink="/hrms/arr/app-establish" routerLinkActive="active">

              Establish Approval
            </a>
          </li>
          <!-- <li>
                        <a routerLink="/hrms/arr/show-data"
                            routerLinkActive="active">
                             All Data
                        </a>
                    </li> -->
          <li [hidden]="!sideBarFlag['HR-R67']">
            <a routerLink="/hrms/payroll/fixed-pay" routerLinkActive="active">
              Variable Pay</a>
          </li>
          <li [hidden]="!sideBarFlag['HR-R68']">
            <a routerLink="/hrms/arr/posting"
              routerLinkActive="active">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar26']}}
              <!-- Posting -->
            </a>
          </li>
          <li [hidden]="!sideBarFlag['HR-R69']">
            <a routerLink="/hrms/arr/promotion"
              routerLinkActive="active">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar27']}}
              <!-- Promotion -->
            </a>
          </li>
          <li [hidden]="!sideBarFlag['HR-R70']">
            <a routerLink="/hrms/arr/probation"
              routerLinkActive="active">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar28']}}
              <!-- Probation -->
            </a>
          </li>
          <li [hidden]="!sideBarFlag['HR-R71']">
            <a routerLink="/hrms/arr/complaint"
              routerLinkActive="active">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar29']}}
              <!-- Complaint -->
            </a>
          </li>
          <li [hidden]="!sideBarFlag['HR-R72']">
            <a routerLink="/hrms/arr/enquiry"
              routerLinkActive="active">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar30']}}
              <!-- Enquiry -->
            </a>
          </li>
          <li [hidden]="!sideBarFlag['HR-R73']">
            <a routerLink="/hrms/arr/suspension"
              routerLinkActive="active">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar31']}}
              <!-- Suspension -->
            </a>
          </li>

          <li [hidden]="!sideBarFlag['HR-R74']">
            <a routerLink="/hrms/arr/termination"
              routerLinkActive="active">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar33']}}
              <!-- Termination -->
            </a>
          </li>
          <li [hidden]="!sideBarFlag['HR-R75']">
            <a routerLink="/hrms/arr/retirement"
              routerLinkActive="active">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar34']}}
              <!-- Retirement -->
            </a>
          </li>
          <li [hidden]="!sideBarFlag['HR-R76']">
            <a routerLink="/hrms/arr/death"
              routerLinkActive="active">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar35']}}
              <!-- Death -->
            </a>
          </li>
          <li [hidden]="!sideBarFlag['HR-R90']">
            <a routerLink="/hrms/arr/reappointment"
              routerLinkActive="active">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar36']}}
              <!-- Reappointment -->
            </a>
          </li>
          <li [hidden]="!sideBarFlag['HR-R91']">
            <a routerLink="/hrms/arr/resign"
              routerLinkActive="active">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar37']}}
              <!-- Resign -->
            </a>
          </li>
          <li [hidden]="!sideBarFlag['HR-R92']">
            <a routerLink="/hrms/arr/transfer"
              routerLinkActive="active">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar38']}}
              <!-- Transfer -->
            </a>
          </li>





        </ul>
      </li>

      <li routerLinkActive="active" [hidden]="!sideBarFlag['HR-R4']">
        <a class="text-decoration-none" href="#" data-bs-toggle="collapse" data-bs-target="#collapseleave"
          aria-expanded="false" aria-controls="collapseleave">
          <i class="sidebar-item-icon  fa fa-commenting" aria-hidden="true"></i>
          <!-- <a [hidden]="leave_hidden" href="javascript:;"><i class="sidebar-item-icon fa fa-gear"></i> -->
          <span class="nav-label">Leave Management</span><i class="fa fa-angle-left arrow"></i></a>
        <ul class="nav-2-level collapse" id="collapseleave" data-bs-parent="#sidebar-collapse">
          <li [hidden]="!sideBarFlag['HR-R77']">
            <a routerLink="/hrms/arr/attendance"
              routerLinkActive="active">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar25']}}
              <!-- Attendance -->
            </a>
          </li>
          <li [hidden]="!sideBarFlag['HR-R78']">
            <a routerLink="/hrms/arr/leaves"
              routerLinkActive="active">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar32']}}
              <!-- Leaves -->
            </a>
          </li>
          <li [hidden]="!sideBarFlag['HR-R79']">
            <a routerLink="/hrms/arr/leaves-apply"
              routerLinkActive="active">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar66']}}
              <!-- Leave Application -->
            </a>
          </li>
          <li [hidden]="!sideBarFlag['HR-R80']">
            <a routerLink="/hrms/arr/leave-list" routerLinkActive="active">Leave List
              <!-- Leave List -->
            </a>
          </li>

        </ul>
      </li>

      <li routerLinkActive="active" [hidden]="!sideBarFlag['HR-R81']">
        <!--   <i class="fa-solid fa-laptop-code"></i> -->
        <a class="text-decoration-none" href="#" data-bs-toggle="collapse" data-bs-target="#collapseTreavel"
          aria-expanded="false" aria-controls="collapseTreavel">
          <!-- <i class="sidebar-item-icon fa fa-address-book" aria-hidden="true"> -->
          <!-- <i class="sidebar-item-icon icon-rocket"></i> -->
          <i class="sidebar-item-icon fa fa-plane" aria-hidden="true"></i>
          <span class="nav-label">Travel Reimbursement</span>
          <i class="fa fa-angle-left arrow"></i>
        </a>
        <ul class="nav-2-level collapse" id="collapseTreavel" data-bs-parent="#sidebar-collapse">
          <li>
            <a [hidden]="!sideBarFlag['HR-R82']" routerLinkActive="active"
              routerLink="/hrms/travelling-reimburement/tour-detail">

              <!-- <span class="nav-label"> -->
              Tour Detail
              <!-- </span> -->
            </a>
            <a [hidden]="!sideBarFlag['HR-R83']" routerLinkActive="active"
              routerLink="/hrms/travelling-reimburement/ta-bill">

              <!-- <span class="nav-label"> -->
              TA Bill
              <!-- </span> -->
            </a>
          </li>

        </ul>
      </li>

      <li routerLinkActive="active" [hidden]="!sideBarFlag['HR-R93']">
        <!--   <i class="fa-solid fa-laptop-code"></i> -->
        <a class="text-decoration-none" href="#" data-bs-toggle="collapse" data-bs-target="#collapseReim"
          aria-expanded="false" aria-controls="collapseReim">
          <!-- <i class="sidebar-item-icon fa fa-address-book" aria-hidden="true"> -->
          <!-- <i class="sidebar-item-icon icon-rocket"></i> -->
          <i class="sidebar-item-icon fa fa-plus-square" aria-hidden="true"></i>
          <span class="nav-label">Reimbursement</span>
          <i class="fa fa-angle-left arrow"></i>
        </a>
        <ul class="nav-2-level collapse" id="collapseReim" data-bs-parent="#sidebar-collapse">
          <li>
            <a [hidden]="!sideBarFlag['HR-R94']" routerLinkActive="active" routerLink="/hrms/medical-reimbrusment/ma">
              Medical Allownace

            </a>
          </li>
          <li>
            <a [hidden]="!sideBarFlag['HR-R95']" routerLinkActive="active"
              routerLink="/hrms/medical-reimbrusment/ta-reimbrusment">
              TA Reimbrusment

            </a>
          </li>
          <li>
            <a [hidden]="!sideBarFlag['HR-R96']" routerLinkActive="active"
              routerLink="/hrms/medical-reimbrusment/ta-advance">
              TA Advance

            </a>
          </li>
        </ul>
      </li>


      <li routerLinkActive="active" [hidden]="!sideBarFlag['HR-R3']">
        <a class="text-decoration-none" href="#" data-bs-toggle="collapse" data-bs-target="#collapsePayroll"
          aria-expanded="false" aria-controls="collapsePayroll"><i class=" sidebar-item-icon fa fa-usd"></i>
          <!-- <a [hidden]="payroll_hidden" href="javascript:;"><i class=" sidebar-item-icon fa fa-usd"></i> -->
          <span class="nav-label">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar39']}}
            <!-- Payroll -->
          </span><i class="fa fa-angle-left arrow"></i></a>
        <ul class="nav-2-level collapse" id="collapsePayroll" data-bs-parent="#sidebar-collapse">
          <!--   <li>
                        <a routerLink="/hrms/payroll/fixed-pay" routerLinkActive="active">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar40']}}
                            Fix Pay</a>
                    </li> -->


          <li>
            <!-- Arrear -->

            <a class="text-decoration-none" href="#" data-bs-toggle="collapse" data-bs-target="#collapseArrer"
              aria-expanded="false" aria-controls="collapseArrer">
              <span
                class="nav-label">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar41']}}</span><i
                class="fa fa-angle-left arrow"></i></a>
            <ul class="nav-3-level collapse collapse2" id="collapseArrer" data-bs-parent="#collapsePayroll">
              <li>
                <a class="text-decoration-none" routerLink="/hrms/payroll/variable-pay/da-arrear">
                  {{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar43']}}
                </a>
              </li>
              <li>
                <a class="text-decoration-none"
                  routerLink="/hrms/payroll/variable-pay/all-arrear">
                  All Arrear
                </a>
              </li>


            </ul>

          </li>
          <!-- <li [hidden]="!sideBarFlag['HR-R84']">
                        <a routerLink="/hrms/payroll/variable-pay/all-arrear" routerLinkActive="active">
                            Arrear
                        </a>
                    </li> -->
          <li [hidden]="!sideBarFlag['HR-R85']">
            <a routerLink="/hrms/payroll/sal-bill" (click)="refreshCol2()"
              routerLinkActive="active">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar44']}}
              <!-- Salary Bill -->
            </a>
          </li>
          <li [hidden]="!sideBarFlag['HR-R86']">
            <a routerLink="/hrms/payroll/sal-start-stop" (click)="refreshCol2()"
              routerLinkActive="active">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar45']}}
              <!-- Salary Start/Stop -->
            </a>
          </li>
          <!-- <li>
                        <a routerLink="/hrms/payroll/pay-slip" routerLinkActive="active">Pay Slip</a>
                    </li>
                    <li>
                        <a routerLink="/hrms/payroll/other-bill" routerLinkActive="active">Other Bill</a>
                    </li> -->
          <li [hidden]="!sideBarFlag['HR-R87']">
            <a routerLink="/hrms/payroll/ann_inc" (click)="refreshCol2()"
              routerLinkActive="active">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar46']}}
              <!-- Annual Increment -->
            </a>
          </li>
          <li [hidden]="!sideBarFlag['HR-R88']">
            <a routerLink="/hrms/payroll/loan" (click)="refreshCol2()"
              routerLinkActive="active">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar47']}}
              <!-- Advances -->
            </a>
          </li>
          <li [hidden]="!sideBarFlag['HR-R89']">
            <a routerLink="/hrms/payroll/el-encash" (click)="refreshCol2()"
              routerLinkActive="active">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar48']}}
              <!-- Leave Encashment -->
            </a>
          </li>
          <!-- <li [hidden]="!sideBarFlag['HR-R99']"> -->
          <li>
            <a routerLink="/hrms/payroll/gratuity" (click)="refreshCol2()"
              routerLinkActive="active"> Gratuity
              <!-- Gratuity -->
            </a>
          </li>
        </ul>
      </li>



      <li [hidden]="!sideBarFlag['HR-R6']">
        <a class="text-decoration-none" href="#" data-bs-toggle="collapse" data-bs-target="#collapseAdmin"
          aria-expanded="false" aria-controls="collapseAdmin"><i class="sidebar-item-icon fa fa-database"></i>
          <span
            class="nav-label">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar56']}}</span><i
            class="fa fa-angle-left arrow"></i></a>
        <!-- Administration -->
        <ul class="nav-2-level collapse" id="collapseAdmin" data-bs-parent="#sidebar-collapse">
          <div id="adminParent">


            <li>
              <a class="text-decoration-none" href="#" data-bs-toggle="collapse" data-bs-target="#set"
                aria-expanded="false" aria-controls="set">
                <span
                  class="nav-label">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar49']}}</span><i
                  class="fa fa-angle-left arrow"></i>
              </a>
              <!-- Master Data -->
              <ul class="nav-3-level collapse" id="set" data-bs-parent="#adminParent">
                <li>
                  <a class="text-decoration-none"
                    routerLink="/hrms/setting/fields">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar50']}}
                    <!-- Fields -->
                  </a>
                </li>
                <li>
                  <a class="text-decoration-none"
                    routerLink="/hrms/setting/code-value">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar51']}}
                    <!-- Code Value -->
                  </a>
                </li>
                <li>
                  <a class="text-decoration-none"
                    routerLink="/hrms/setting/leave-def">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar52']}}
                    <!--  Leave Rule --></a>
                </li>

                <li>
                  <a class="text-decoration-none"
                    routerLink="/hrms/setting/salary-rule">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar70']}}
                    <!--  Salary Rule --></a>
                </li>

                <li>
                  <a class="text-decoration-none"
                    routerLink="/hrms/setting/matrix">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar54']}}
                    <!-- Pay Matrix -->
                  </a>
                </li>
                <li>
                  <a class="text-decoration-none" routerLink="/hrms/setting/city-matrix">
                    City Group</a>
                </li>
                <li>
                  <a class="text-decoration-none" routerLink="/hrms/setting/cca-matrix">
                    CCA Matrix</a>
                </li>
                <li>
                  <a class="text-decoration-none" routerLink="/hrms/setting/hra-matrix">
                    HRA Matrix</a>
                </li>
                <li>
                  <a class="text-decoration-none" routerLink="/hrms/setting/pbr-matrix">
                    PBR Matrix</a>
                </li>
                <li>
                  <a class="text-decoration-none" routerLink="/hrms/setting/welfare-fund">
                    WF MATRIX</a>
                </li>

                <li >
                  <a routerLink="/hrms/setting/travel-matrix" routerLinkActive="active">
                     Travel MATRIX</a>
              </li>

                <li>
                  <a class="text-decoration-none"
                    routerLink="/hrms/setting/salary-rules">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar55']}}
                    <!-- Pay Rule -->
                  </a>
                </li>
                <li>
                  <a class="text-decoration-none" routerLink="/hrms/setting/budget-info">
                    Budget </a>
                </li>
                <li>
                  <a class="text-decoration-none" routerLink="/hrms/setting/product-info">
                    Product</a>
                </li>
                <li>
                  <a class="text-decoration-none" routerLink="/hrms/setting/pay-component">
                    Activity</a>
                </li>
                <!-- <li>
                                          <a class = "text-decoration-none" routerLink="/hrms/setting/appr"  >Document Tracking</a>
                                      </li> -->
              </ul>
            </li>

            <li>
              <!-- security -->

              <a class="text-decoration-none" href="#" data-bs-toggle="collapse" data-bs-target="#sec"
                aria-expanded="false" aria-controls="sec">
                <span
                  class="nav-label">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar67']}}</span><i
                  class="fa fa-angle-left arrow"></i></a>
              <ul class="nav-3-level collapse" id="sec" data-bs-parent="#adminParent">
                <li>
                  <a class="text-decoration-none" routerLink="/hrms/administration/roles">
                    {{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar57']}}
                    <!-- Role -->
                  </a>
                </li>
                <li>
                  <a class="text-decoration-none"
                    routerLink="/hrms/administration/users">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar58']}}
                    <!-- Users -->
                  </a>
                </li>

                <li>
                  <a class="text-decoration-none" routerLink="/hrms/administration/hierarchy">
                    {{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar59']}}
                  </a>
                </li>
                <li>
                  <a class="text-decoration-none" routerLink="/hrms/administration/data-assignment">
                    {{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar60']}}
                  </a>
                </li>
                <li>
                  <a class="text-decoration-none" routerLink="/hrms/administration/hr-workflow">
                    WorkFlow
                  </a>
                </li>
                <li>
                  <a class="text-decoration-none" routerLink="/hrms/arr/show-data">
                    <!-- {{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar24']}} -->
                    All Data
                  </a>
                </li>
              </ul>

            </li>

            <!-- Avinash Mishra/ Attend-management -->
            <li>
              <a class="text-decoration-none" href="#" data-bs-toggle="collapse" data-bs-target="#attendM"
                aria-expanded="false" aria-controls="attendM">
                <span class="nav-label">Attend-Management</span><i class="fa fa-angle-left arrow"></i></a>
              <ul class="nav-3-level collapse" id="attendM" data-bs-parent="#adminParent">
                <li>

                  <a class="text-decoration-none" routerLink="/hrms/attendanceManagement">
                    Attandance Rule
                  </a>
                  <a class="text-decoration-none" routerLink="/hrms/attendance_manag/calendar-rule">
                    Calendar Rule
                  </a>
                  <a class="text-decoration-none" routerLink="/hrms/attendance_manag/boundry-map">
                    Boundary Map
                  </a>
                </li>

              </ul>
            </li>
          </div>
        </ul>
      </li>

      <!-- Extrawork Management -->
      <li [hidden]="!sideBarFlag['HR-R35']">
        <!--   <i class="fa-solid fa-laptop-code"></i> -->
        <a class="text-decoration-none" href="#" data-bs-toggle="collapse" data-bs-target="#collapseExtra"
          aria-expanded="false" aria-controls="collapseExtra">

          <!-- <i class="sidebar-item-icon fa fa-address-book" aria-hidden="true"> -->
          <!-- <i class="sidebar-item-icon icon-rocket"></i> -->
          <i class="sidebar-item-icon fa fa-file-word-o" aria-hidden="true"></i>
          <span class="nav-label">Extra Work</span>
          <i class="fa fa-angle-left arrow"></i>
        </a>
        <!-- <a href="javascript:;"> <i class="fa fa-wordpress" ></i>
                    <span class="nav-label">Extra Work </span><i class="fa fa-angle-left arrow"></i></a> -->
        <ul class="nav-2-level collapse" id="collapseExtra" data-bs-parent="#sidebar-collapse">
          <li [hidden]="!sideBarFlag['HR-R36']">
            <a routerLinkActive="active" routerLink="/hrms/extrawork"><i class="fa-solid fa-laptop-code"></i>
              <span class="nav-label">Extra Work Permission
                <!-- Extra Work -->
              </span>
            </a>
          </li>
          <li [hidden]="!sideBarFlag['HR-R37']">
            <a routerLinkActive="active" routerLink="/hrms/late_sitting"><i class="fa-solid fa-laptop-code"></i>
              <span class="nav-label">Late Sitting
                <!-- Extra Work -->
              </span>
            </a>
          </li>
        </ul>
      </li>

      <li [hidden]="!sideBarFlag['HR-R38']">
        <!--   <i class="fa-solid fa-laptop-code"></i> -->
        <a class="text-decoration-none" href="#" data-bs-toggle="collapse" data-bs-target="#collapseACR"
          aria-expanded="false" aria-controls="collapseACR"><i class="sidebar-item-icon fa fa-address-book"
            aria-hidden="true"></i>
          <span class="nav-label">ACR</span><i class="fa fa-angle-left arrow"></i></a>
        <ul class="nav-1-level collapse" id="collapseACR" data-bs-parent="#sidebar-collapse">
          <li [hidden]="!sideBarFlag['HR-R39']">
            <a routerLinkActive="active" routerLink="/hrms/annual_conf_report/acr">

              <span class="nav-label">
                Annual Confidential Report
              </span>
            </a>
          </li>

        </ul>
      </li>


      <li>
        <a class="text-decoration-none" href="#" data-bs-toggle="collapse" data-bs-target="#collapseHelp"
          aria-expanded="false" aria-controls="collapseHelp"><i class="sidebar-item-icon fa fa-question-circle"></i>
          <span class="nav-label">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar61']}}
            <!-- Help -->
          </span><i class="fa fa-angle-left arrow"></i></a>
        <ul class="nav-2-level collapse" id="collapseHelp" data-bs-parent="#sidebar-collapse">
          <li>
            <a class="text-decoration-none"
              routerLink="/hrms/help/faq">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar62']}}
              <!-- FAQ -->
            </a>
          </li>
          <li>
            <a class="text-decoration-none"
              routerLink="/hrms/help/doc">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar63']}}
              <!-- User Manual -->
            </a>
          </li>
          <li>
            <a class="text-decoration-none"
              routerLink="/hrms/help/videos">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar64']}}
              <!-- Tutorial Videos -->
            </a>
          </li>
          <li>
            <a class="text-decoration-none"
              routerLink="/hrms/help/online-support">{{this.mainService.allLableShowObjHR[mainService.language_cd+'hr_sidebar65']}}
              <!-- Online Support -->
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</div>
